// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"7db1cf2b","348":"49b2c49a","571":"08231973","924":"8f73f295"}[chunkId] + ".chunk.js";
};